import { getProductList } from "@/services/product"
import utils from "@/utils/utils"
export default {
  getProductList(self) {
    let page = self.page
      let keyword = self.productName
      let cid = self.currentCategory ? self.currentCategory.cid : ''
      let data = { page, keyword }
      let rankBy = self.rankBy
      let rankDuration = self.rankDuration
      let from = self.searchClient ? self.searchClient : ''
      if (rankBy) Object.assign(data, {rankBy})
      if(rankDuration) Object.assign(data,{rankDuration})
      if(cid != '-1') Object.assign(data, {cid})
      if(from) Object.assign(data, {from})
      
      self.$showToast({
        type: 'loading',
        toastMessage: '正在加载数据...',
        duration: 2000 
      })
      getProductList(data).then(res => {
          res.data.goods.forEach(good => {
              good.couponTime = utils.formatTime(new Date(good.commissionInfo.endTime))
              self.productList.push(good)
          })
          self.hasMore = res.data.hasMore
      }).catch(() => {
        self.showToast = false
      })
      // console.log(cur)
    },
    getCategoryList(self) {
      let page = self.page
      let keyword = self.productName
      let cid = self.currentCategory.cid //currentCid
      let data = { page, keyword }
      let rankBy = self.rankBy
      let rankDuration = self.rankDuration
      if (rankBy) Object.assign(data, {rankBy})
      if(rankDuration) Object.assign(data,{rankDuration})
      if(cid != '-1') Object.assign(data, {cid})
      getProductList(data).then(res => {
          res.data.goods.forEach(good => {
              good.couponTime = utils.formatTime(new Date(good.commissionInfo.endTime))
              self.data.productList.push(good)
          })
          self.hasMore = res.data.hasMore
      }).catch(() => {
      })
    }
  }
